<template>
  <div :class="['cookie-banner', { 'cookie-banner--canada': isCanada }]" v-if="show">
    <slot/>
    <button class="btn-close" @click="close">
      <slot name="close-btn"/>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'cookie-banner',
    props: {
      policeUpdated: { type: Boolean, required: false, default: false },
      cookieName: { type: String, required: false, default: 'cookie-notification' }
    },
    data() {
      return {
        show: true,
      };
    },
    computed: {
      isCanada() {
        return this.cookieName.indexOf('canada') !== -1;
      }
    },
    mounted() {
      if (this.getCookie(this.cookieName)) {
        this.show = false;
      }
      if (this.policeUpdated) {
        this.eraseCookie(this.cookieName);
        this.show = true;
      }
    },
    methods: {
      close() {
        this.setCookie(this.cookieName, 1, 365);
        this.show = false;
      },
      setCookie(name, value, days) {
        let expires = '';
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '')  + expires + '; SameSite=Strict; path=/';
      },
      getCookie(name) {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
          const trimmedCookie = cookie.trim(); // Remove leading spaces
          if (trimmedCookie.startsWith(nameEQ)) {
            return trimmedCookie.substring(nameEQ.length);
          }
        }
        return null;
      },
      eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
      }
    }
  };
</script>
<style src="./CookieBanner.scss" lang="scss"></style>
